import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";

function Contact() {
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.get("/Admin_ContactUs_List");

      responceRight = responceRight?.data?.data;
      console.log("My_Team", responceRight);
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          f_name: item?.f_name,
          l_name: item?.l_name,
          query: item?.query,
          edate: item?.edate,
          email: item.email,
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "First Name", accessor: "f_name" },
      { Header: "Last Name", accessor: "l_name" },
      { Header: "Email", accessor: "email" },
      { Header: "Query", accessor: "query" },
      { Header: "Date", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title"> Query</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      ng-submit="SearchUserid();"
                      class="ng-pristine ng-valid ng-valid-maxlength"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div class="panel panel-default">
                            <div
                              class="panel-body"
                              style={{ overflow: "scroll" }}
                            >
                              <Table
                                data={currentPostleft}
                                columns={my_team.cols}
                              />

                              <Table_Buttons
                                indexOfFirstPage={indexOfFirstPage2}
                                indexOfLastPost={indexOfLastPost2}
                                setcurrentPage={setcurrentPage2}
                                currentPage={currentPage2}
                                totalData={leftreferralApi.length}
                                listPerpage={listPerpage2}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div class="col-md-12"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
